import { useEffect, useState } from 'react';
import { getFirestore, getDoc, doc, addDoc, getDocs, collection } from 'firebase/firestore';
import app from '../firebase';

export default function Admin() {

    const [productCategories, setProductCategories]     = useState();
    const [foodCategories, setFoodCategories]           = useState();
    const [serviceCategories, setServiceCategories]     = useState();
    const [propertyCategories, setPropertyCategories]   = useState();

    const [newCategory, setNewCategory]   = useState();
    const [testimonials, setTestimonials] = useState();
    const [message, setMessage]           = useState();
    const [by, setBy]                     = useState();
    const [totalUsers, setTotalUsers]     = useState();
    const [profile, setProfile]           = useState();

    const getProductCategories = async () => {
        let x = [];

        await getDocs(collection(getFirestore(app), 'product_categories'))
            .then(results => {
                results.forEach(i => {
                    x.push([i.id, i.data()]);
                })
            });

        setProductCategories(x);
    }

    const getFoodCategories = async () => {
        let x = [];

        await getDocs(collection(getFirestore(app), 'food_categories'))
            .then(results => {
                results.forEach(i => {
                    x.push([i.id, i.data()]);
                })
            });

        setFoodCategories(x);
    }

    const getServiceCategories = async () => {
        let x = [];

        await getDocs(collection(getFirestore(app), 'service_categories'))
            .then(results => {
                results.forEach(i => {
                    x.push([i.id, i.data()]);
                })
            });

        setServiceCategories(x);
    }

    const getPropertyCategories = async () => {
        let x = [];

        await getDocs(collection(getFirestore(app), 'property_categories'))
            .then(results => {
                results.forEach(i => {
                    x.push([i.id, i.data()]);
                })
            });

        setPropertyCategories(x);
    }


    // add categories
    const addProductCategory = () => {
        addDoc(collection(getFirestore(app), 'product_categories'), { name: newCategory });
    }

    const addFoodCategory = () => {
        addDoc(collection(getFirestore(app), 'food_categories'), { name: newCategory });
    }

    const addServiceCategory = () => {
        addDoc(collection(getFirestore(app), 'service_categories'), { name: newCategory });
    }

    const addPropertyCategory = () => {
        addDoc(collection(getFirestore(app), 'property_categories'), { name: newCategory });
    }

    const getProfile = () => {
        if (!localStorage.getItem('userId')) return window.location.replace('/');
        getDoc(doc(getFirestore(app), 'users', localStorage.getItem('userId')))
            .then(result => {
                if (!result.data().admin) return window.location.replace('/');
                setProfile([result.id, result.data()]);
            });
    }

    const countTotalUsers = () => {
        getDocs(collection(getFirestore(app), 'users'))
            .then(results => setTotalUsers(results.size));
    }

    const createTestimonial = () => {
        addDoc(collection(getFirestore(app), 'testimonials'), { message, by });
        return alert('You have sucessfully created a testimonial of your customer!')
    }

    const getTestimonials = async () => {
        let x = [];

        await getDocs(collection(getFirestore(app), 'testimonials'))
            .then(results => results.forEach(i => x.push([i.id, i.data()])));

        setTestimonials(x);
    }

    const Dashboard = () => {
        return(
            <div className="bg-dark bg-light text-light p-4">
                <span className="d-block fw-bold">Total Users: {totalUsers}</span>
            </div>
        )
    }

    useEffect(() => {
        getProfile();
        getProductCategories();
        getFoodCategories();
        getServiceCategories();
        getPropertyCategories();
        countTotalUsers();
        getTestimonials();
    });

    return(
        <>
            <div className="container-fluid bg-light min-vh-100 p-4">
                <Dashboard />

                <br />

                <div className="row">

                    <div className="col-lg-3">
                        <label className="form-label">Product Category</label>
                        <div className="input-group">
                            <input type="text" className="form-control" onChange={data => setNewCategory(data.target.value)} />
                            <button className="btn btn-dark" onClick={addProductCategory}>Create</button>
                        </div>

                        { productCategories && productCategories.map(i => <span className="d-block">{i[1].name}</span>) }
                    </div>

                    <div className="col-lg-3">
                        <label className="form-label">Food Category</label>
                        <div className="input-group">
                            <input type="text" className="form-control" onChange={data => setNewCategory(data.target.value)} />
                            <button className="btn btn-dark" onClick={addFoodCategory}>Create</button>
                        </div>

                        { foodCategories && foodCategories.map(i => <span className="d-block">{i[1].name}</span>) }
                    </div>

                    <div className="col-lg-3">
                        <label className="form-label">Service Category</label>
                        <div className="input-group">
                            <input type="text" className="form-control" onChange={data => setNewCategory(data.target.value)} />
                            <button className="btn btn-dark" onClick={addServiceCategory}>Create</button>
                        </div>

                        { serviceCategories && serviceCategories.map(i => <span className="d-block">{i[1].name}</span>) }
                    </div>

                    <div className="col-lg-3">
                        <label className="form-label">Property Category</label>
                        <div className="input-group">
                            <input type="text" className="form-control" onChange={data => setNewCategory(data.target.value)} />
                            <button className="btn btn-dark" onClick={addPropertyCategory}>Create</button>
                        </div>

                        { propertyCategories && propertyCategories.map(i => <span className="d-block">{i[1].name}</span>) }
                    </div>

                </div>

                <br />

                <div className="row">
                    <div className="col-lg-4">
                        <textarea className="form-control mb-2" rows="10" placeholder="Testominial Message" onChange={data => setMessage(data.target.value)}></textarea>
                        <input type="text" className="form-control mb-2" placeholder="Full Name" onChange={data => setBy(data.target.value)} />
                        <button className="btn btn-dark w-100" onClick={createTestimonial}>Post Testimonial</button>
                    </div>
                    <div className="col-lg-8">
                        <h4>Testimonials</h4>
                        
                        {
                            testimonials && testimonials.map(i => (
                                <>{ i[1].testimonial }</>
                            ))
                        }
                    </div>
                </div>
            </div>
        </>
    )
}